import { render, staticRenderFns } from "./HallOfFame.vue?vue&type=template&id=014b9e52&"
import script from "./HallOfFame.vue?vue&type=script&lang=js&"
export * from "./HallOfFame.vue?vue&type=script&lang=js&"
import style0 from "./HallOfFame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDataTable,VProgressLinear})
